/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hist_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Histogram Maker (Free, Online) — Toolverse`)
};

const es_hist_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador de Histogramas (Gratis, Online) — Toolverse`)
};

const de_hist_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Histogramm-Ersteller (Kostenlos, Online) — Toolverse`)
};

const nl_hist_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Histogrammaker (gratis, online) — Toolverse`)
};

const fr_hist_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur d'histogramme (gratuit, en ligne) — Toolverse`)
};

const it_hist_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore di istogrammi (gratuito, online) — Toolverse`)
};

const pt_br2_hist_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Histograma (Grátis, Online) — Toolverse`)
};

const pt_hist_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de Histogramas (Grátis, Online) — Toolverse`)
};

const ja_hist_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヒストグラム作成ツール（無料・オンライン） — Toolverse`)
};

const zh_hist_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直方图制作工具（免费在线）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hist_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hist_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hist_meta_title", locale)
	if (locale === "en") return en_hist_meta_title(inputs)
	if (locale === "es") return es_hist_meta_title(inputs)
	if (locale === "de") return de_hist_meta_title(inputs)
	if (locale === "nl") return nl_hist_meta_title(inputs)
	if (locale === "fr") return fr_hist_meta_title(inputs)
	if (locale === "it") return it_hist_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_hist_meta_title(inputs)
	if (locale === "pt") return pt_hist_meta_title(inputs)
	if (locale === "ja") return ja_hist_meta_title(inputs)
	return zh_hist_meta_title(inputs)
};